import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
//import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { connect } from "react-redux";
import LayoutOne from "../../layouts/LayoutOne";
//import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import RelatedProductSlider from "../../wrappers/product/RelatedProductSlider";
import ProductDescriptionTab from "../../wrappers/product/ProductDescriptionTab";
import ProductImageDescription from "../../wrappers/product/ProductImageDescription";
import ProductGridQta from "../../wrappers/product/ProductGridQta";
import { getProductCartQty } from "../../helpers/product";
import { useToasts } from "react-toast-notifications";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { addToCart } from "../../redux/actions/cartActions";
import ProductMobile from "./ProductMobile";
import { set } from "lodash";

const Product = (props) => {
  const {
    location,
    product,
    userData,
    cartItems,
    addToCart,
    description,
    products,
    productsListini,
  } = props;
  var informazioni = global.informazioni;
  const isLoggedUser =
    userData?.user?.user &&
      (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;
  const isBetaRicambi = global.aziendaID === 4 ? true : false;
  const clienteVisualizzaPrezzi =
    isLoggedUser && userData?.user?.user?.showPrice
      ? userData?.user?.user?.showPrice
      : false;
  const visualizzaPrezzi = isBetaRicambi
    ? clienteVisualizzaPrezzi
    : isLoggedUser || global.visualizzaPrezziLogOut;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;
  const history = useHistory();
  const { pathname } = location;
  var strings = require("../../translations/italian.json");
  const variations = product?.variation ? product.variation : [];
  const [qta, setQta] = useState(table);
  const [numTaglie, setNumTaglie] = useState(0);
  const [IDArtSta, setIDArtSta] = useState(0);
  const [refreshProduct, setRefreshProduct] = useState(false);
  useEffect(() => {
    if (!product) return;
    setQta(table);
    var arrayItemSizeMax = 0;
    var index = 0;

    variations.map((variation, index) => {
      if (
        variation?.size?.length > 0 &&
        variation?.size?.length > arrayItemSizeMax
      ) {
        arrayItemSizeMax = variation?.size?.length;
        setNumTaglie(index);
      }
    });
    console.log(product);
  }, [variations]);

  useEffect(() => {
    setIDArtSta(parseInt(sessionStorage.getItem("IDArtSta")) || 0);
  }, []);

  useEffect(() => {
    setIDArtSta(parseInt(sessionStorage.getItem("IDArtSta")) || 0);
    if (global.aziendaID !== 3) return;
    if (!product) return;
    var v = product.variation;
    v = v.map((color) => {
      if (color && color.size) {
        color.size = color.size.map((size) => {
          var listino = productsListini.find((L) =>
            L.IDArt == size.IDArtSizeColor && (product.tag.includes("GADGET")
              ? true
              : L.IDArtSta ==
              (parseInt(sessionStorage.getItem("IDArtSta")) || 0))
          )?.Pre;

          size.pricesco = listino ? listino : 0;
          if (listino && listino > 0) color.count = (color.count || 0) + 1;
          return size;
        });
        return color;
      }
    });
    console.log(v);
    v = v.filter((color) => color.count > 0); //modifica temporanea per mostrare tutte le tablie e colori anche senza prezzo
    product.variation = v;
    setRefreshProduct(!refreshProduct);
  }, [product, IDArtSta]);

  var table = variations.map((singles, key) => {
    if (singles && singles.size)
      return singles.size.map((single, key) => {
        single.qta = 0;
        single.color = singles.color;
        ////console.log(single)
        return single;
      });
  });

  const { addToast } = useToasts();
  var iTipoGestione = 2;

  function gestisciQta(
    QtaOrdinate,
    QtaDisponibili,
    QtaArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo,
    promo
  ) {
    catalogo = 1;
    /*Opzioni Possibili: 
        0   Non Bloccare le Qta
        1   Bloccare + Messaggio a QtaDisponibili < QtaOrdinate
        2   Messaggio a QtaDisponibili < QtaOrdinate
        3   Bloccare + Messaggio a QtaDisponibili + QtaArrivo < QtaOrdinate
        4   Messaggio a QtaDisponibili + QtaArrivo < QtaOrdinate
    */

    var QtaGiaInCarrello = productCartQty(
      selectedProductColor,
      selectedProductSize
    );

    var sToast = "";
    var sTipoToast = "info"; //success, error, warning, info
    var QtaConfronto = QtaDisponibili - QtaGiaInCarrello;
    var iTipoGestioneAtt = iTipoGestione;
    if (promo) {
      catalogo = 0;
      iTipoGestioneAtt = 2;
    }
    var QtaPossibili = QtaOrdinate;

    if (iTipoGestioneAtt > 2) {
      QtaConfronto = QtaConfronto + QtaArrivo;
      iTipoGestioneAtt = iTipoGestioneAtt - 2;
    }

    if (QtaOrdinate <= 0) {
      if (QtaOrdinate == 0) return QtaOrdinate;
      addToast("Quantità non consentite", {
        appearance: "warning",
        autoDismiss: true,
        placement: "bottom-left",
      });
      return 0;
    } else {
      if (catalogo == 1) iTipoGestioneAtt = 0;
      switch (iTipoGestioneAtt) {
        case 0:
          sToast = "Quantità inserite correttamente";
          sTipoToast = "info";
          break;
        case 1:
        case 2:
          if (QtaOrdinate > QtaConfronto) {
            sToast = "Quantità eccessive, non è possibile caricare le quantità";
            sTipoToast = "warning";
            if (iTipoGestioneAtt == 2) {
              QtaPossibili = QtaConfronto < 0 ? 0 : QtaConfronto;
            }
          } else {
            sToast = "Quantità inserite correttamente";
            sTipoToast = "info";
          }
          break;
      }
    }

    //Meglio non farlo visualizzare in continuazione, enilio 29/06/2021 if (sToast != "") addToast(sToast, {appearance: sTipoToast, autoDismiss: true, placement: 'bottom-left' });

    return QtaPossibili;
  }

  function getDisponibili(
    Qta,
    inArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo,
    impCli,
    promo,
    nonPrenotabile
  ) {
    var sDis = " ";

    if (Qta <= 0 || Qta - inArrivo <= 0)
      sDis = (
        <div style={{ fontWeight: "500" }}>
          Non Disponibile &nbsp;
          {nonPrenotabile ? <i className="fa fa-bell"></i> : null}
        </div>
      );
    else if (!promo)
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Disponibili: " + (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo)}
          <br />
        </div>
      );
    else
      sDis = (
        <div style={{ fontWeight: "500" }}>
          {"Ultimi  " +
            (Qta - inArrivo > 500 ? "500+" : Qta - inArrivo) +
            " pezzi"}
          <br />
        </div>
      );
    //sDis = "Disponibili: " + (Qta - productCartQty(selectedProductColor, selectedProductSize));
    if (catalogo && Qta <= 0) {
      //sDis = <>{sDis}<br/>{"Su prenotazione"}</>
      sDis = (
        <div style={{ fontSize: "12px", fontWeight: "100" }}>
          <br />
          {"Su prenotazione"}
        </div>
      );
    }

    return sDis;
  }

  function getQtaInArrivo(
    qtaOrdFor,
    qtaImpCli,
    qta,
    catalogo,
    promo,
    onlyString
  ) {
    var sDis = " ";
    var Qta = qta - qtaOrdFor > 0 ? qtaOrdFor : qta;
    if (promo)
      return onlyString ? (
        ""
      ) : (
        <p>
          <br />
          <br />
          <br />
        </p>
      );

    if (Qta <= 0 || qtaImpCli < 0)
      //sDis = "Non in Arrivo";
      sDis = onlyString ? (
        "su Prenotazione"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            <br />
            <br />
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );
    else
      sDis = onlyString ? (
        (Qta || "0") + " 5/7 gg"
      ) : (
        <>
          <div style={{ fontSize: "12px", fontWeight: "500" }}>
            In Arrivo: {Qta ? Qta : "0"}
            <br />
            in 5/7 gg
          </div>
          <div style={{ fontSize: "12px", fontWeight: "100" }}>
            <br />
            Maggiori quantità
            <br />
            su prenotazione
          </div>
        </>
      );

    return sDis;
  }

  function toColor(i) {
    /*var hex = (i & 0xFF).toString(16) +
            ((i >> 8) & 0xFF).toString(16) +
            ((i >> 16) & 0xFF).toString(16) +
            ((i >> 24) & 0xFF).toString(16);
  
    hex = hex.substring(0, 6);
    
    return "#" + hex;*/
    var r = Math.floor(i / 65536);
    var g = Math.floor((i - r * 65536) / 256);
    var b = Math.floor(i - r * 65536 - g * 256);
    var rHex = Number(r).toString(16);
    var gHex = Number(g).toString(16);
    var bHex = Number(b).toString(16);
    rHex = rHex.length < 2 ? "0" + rHex : rHex;
    gHex = gHex.length < 2 ? "0" + gHex : gHex;
    bHex = bHex.length < 2 ? "0" + bHex : bHex;
    return "#" + bHex + gHex + rHex;
  }

  function productCartQty(selectedProductColor, selectedProductSize, withGrid) {
    let cartValue = getProductCartQty(
      cartItems,
      product,
      selectedProductColor.trim(),
      selectedProductSize
    );

    //if (withGrid) cartValue +=  getQta(selectedProductSize, selectedProductColor, true);
    return cartValue;
  }

  function onBlur(id, QtaOrdinate, QtaDisponibili, QtaArrivo, catalogo, promo) {
    //console.log(qta);
    var element = document.getElementById(id);
    var selectedProductSize = element.getAttribute("data-size");
    var selectedProductColor = element
      .getAttribute("data-color")
      .replace(" ", "");

    //console.log(selectedProductSize + " " + selectedProductColor);
    var QtaOrdinateGestite = gestisciQta(
      QtaOrdinate,
      QtaDisponibili,
      QtaArrivo,
      selectedProductColor,
      selectedProductSize,
      catalogo,
      promo
    );

    var element = document.getElementById(id);
    element.value = QtaOrdinateGestite;
    QtaOrdinate = QtaOrdinateGestite;

    setQta((prevState) =>
      prevState.map((row) =>
        row?.map((col) =>
          col.IDArtSizeColor === id ? { ...col, qta: QtaOrdinate } : col
        )
      )
    );
  }

  const getQta = (_taglia, _colore, conSegno) => {
    if (!qta) return -1;
    //metodo 1 let _productSizeColor;
    // metodo 1 qta.find(row => row?.find(col => {if (col.name === 'XS' && col.color === 'WH-BIANCO ') _productSizeColor = col}));
    // metodo 2
    const returnValue =
      qta
        .find((row) =>
          row?.find((col) => col.name === _taglia && col.color === _colore)
        )
        ?.find((_t) => _t.name === _taglia && _t.color === _colore)?.qta || 0;
    const conPrefisso =
      conSegno && returnValue != 0 ? " + " + returnValue : returnValue;
    return conPrefisso;
  };

  if (!product) return null;
  const addCart = () => {
    addToCart(
      product,
      addToast,
      document.getElementById("qta").value,
      null,
      null,
      null,
      null,
      null
    );
    document.getElementById("qta").value = 0;
  };
  var qtaInCart = getProductCartQty(cartItems, product, null, null);
  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.shop} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.shop + " " + strings.siteContent}
        />
      </MetaTags>

      {product && userData && (
        <LayoutOne>
          {/* breadcrumb */}

          {/* product description with image */}
          {/*//console.log("Ecco il Prodotto")*/}
          {IDArtSta > 0 && (
            <div
              style={{
                marginBottom: "20px",
                textAlign: "center",
                position: "fixed",
                zIndex: 1000,
                top: "50px",
                backgroundColor: "white",
                width: "100%",
              }}
            >
              Hai selezionato la grafica
              <img
                src={
                  global.baseUrlImage +
                  products.find((p) => p.id == IDArtSta)?.image[0]
                }
                alt=""
                style={{ width: "50px", marginLeft: "10px" }}
              />{" "}
              {products.find((p) => p.id == IDArtSta)?.sku} -{" "}
              {products.find((p) => p.id == IDArtSta)?.name}
            </div>
          )}
          <div className="col-xl-12 col-lg-12 d-none d-lg-block pt-50">
            <ProductImageDescription
              productCartQty={productCartQty}
              getDisponibili={getDisponibili}
              getQtaInArrivo={getQtaInArrivo}
              toColor={toColor}
              spaceTopClass="pt-20"
              spaceBottomClass="pb-20"
              product={product}
              description={description}
              isLoggedUser={isLoggedUser}
              visualizzaPrezzi={visualizzaPrezzi}
              visualizzaGriglia={visualizzaGriglia}
              visualizzaQuantita={visualizzaQuantita}
              refreshProduct={refreshProduct}
            />
            {global.aziendaID == 4 && (
              <ProductDescriptionTab
                spaceBottomClass="pb-90"
                productFullDesc={product?.fullDescription}
                product={product}
              />
            )}
            {/* related product slider */}
            {global.aziendaID != 3 && (
              <RelatedProductSlider
                thisProduct={product?.id}
                spaceBottomClass="pb-20"
                category={product?.category}
                template={product?.templates}
              />
            )}
            {/*griglia per le quantità*/}
            {variations.length > 0 ? (
              <ProductGridQta
                numTaglie={numTaglie}
                variations={variations}
                setQta={setQta}
                table={table}
                qta={qta}
                onBlur={onBlur}
                productCartQty={productCartQty}
                getDisponibili={getDisponibili}
                getQtaInArrivo={getQtaInArrivo}
                toColor={toColor}
                product={product}
                spaceBottomClass="pb-20"
                isLoggedUser={isLoggedUser}
                visualizzaPrezzi={visualizzaPrezzi}
                visualizzaGriglia={visualizzaGriglia}
                visualizzaQuantita={visualizzaQuantita}
              />
            ) : null}
            {/* product description tab */}
            {global.aziendaID != 4 && (
              <ProductDescriptionTab
                spaceBottomClass="pb-90"
                productFullDesc={product?.fullDescription}
                product={product}
              />
            )}
          </div>

          {(global.aziendaID == 1 ||
            global.aziendaID == 2 ||
            global.aziendaID == 4) && (
              <div className="d-block d-lg-none" style={{ padding: "10px" }}>
                <ProductMobile
                  {...props}
                  isLoggedUser={isLoggedUser}
                  product={product}
                  visualizzaPrezzi={visualizzaPrezzi}
                  addToast={addToast}
                />
              </div>
            )}
        </LayoutOne>
      )}
    </Fragment>
  );
};

Product.propTypes = {
  location: PropTypes.object,
  product: PropTypes.object,
};
const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedIDArt,
      Ord1,
      Ord2
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedIDArt,
          Ord1,
          Ord2
        )
      );
    },
  };
};
const mapStateToProps = (state, ownProps) => {
  const productId = ownProps.match.params.id;

  return {
    products: state.productData.products,
    product: state.productData.products.filter(
      (single) => single.id == productId
    )[0],
    description: state.productData.productDescriptions?.filter(
      (D) => D.ID == productId
    )[0],
    userData: state.userData,
    cartItems: state.cartData,
    productsListini:
      state.productData.productListini instanceof String
        ? JSON.parse(state.productData.productListini)
        : state.productData.productListini,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Product);
